var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M1 17.333V6.667C1 5.194 2.515 4 4.385 4h15.23C21.485 4 23 5.194 23 6.667v10.666C23 18.806 21.485 20 19.615 20H4.385C2.515 20 1 18.806 1 17.333"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m22 5-7.879 7.879a3 3 0 0 1-4.242 0L2 5M22 20l-7-8M2 20l7-8"
})));
export default SvgEmail;